import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { PlayCircle, Layers } from "lucide-react";
import { egp, mediaUrl } from "@/lib/api";

const TILTS = ["-rotate-1", "rotate-1", "-rotate-[0.5deg]"];

export const CourseCard = ({ course, index = 0 }) => (
  <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
    transition={{ duration: 0.45, delay: index * 0.08 }}>
    <Link to={`/courses/${course.slug}`} data-testid={`course-card-${course.slug}`}
      className={`group block rounded-3xl bg-white sticker overflow-hidden transition-transform duration-300 hover:-translate-y-2 hover:rotate-0 ${TILTS[index % 3]}`}>
      <div className="relative aspect-[16/10] overflow-hidden bg-[var(--kh-elevated)]">
        {course.cover_image && (
          <img src={mediaUrl(course.cover_image)} alt={course.title} loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#5A1C96]/60 to-transparent" />
        <span className="absolute top-3 right-3 px-3 py-1 rounded-full bg-white text-brand text-xs font-bold border-2 border-[var(--kh-deep)]">{course.category}</span>
        <PlayCircle className="absolute bottom-3 left-3 text-white opacity-0 group-hover:opacity-100 transition-opacity" size={40} />
      </div>
      <div className="p-6 space-y-3">
        <h3 className="font-heading text-xl font-bold text-ink leading-snug">{course.title}</h3>
        {course.subtitle && <p className="text-sm text-soft line-clamp-2">{course.subtitle}</p>}
        <div className="flex items-center justify-between pt-2">
          <span className="flex items-center gap-1 text-xs text-soft"><Layers size={14} />{course.lessons_count || 0} درس • {course.level}</span>
          <span className="text-left">
            {course.old_price > 0 && <span className="block text-xs line-through text-soft/60">{egp(course.old_price)}</span>}
            <span className="font-display text-2xl text-brand" data-testid={`course-card-price-${course.slug}`}>{course.price > 0 ? egp(course.price) : "مجاني"}</span>
          </span>
        </div>
      </div>
    </Link>
  </motion.div>
);
